import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "M18.5 23.75V1m0 0 5.25 6.125M18.5 1l-5.25 6.125"
      }),
      _createElementVNode("path", { d: "M11.5 36h14c4.95 0 7.425 0 8.962-1.538C36 32.925 36 30.45 36 25.5v-1.75c0-4.95 0-7.424-1.538-8.962-1.344-1.345-3.406-1.514-7.212-1.535m-17.5 0c-3.806.021-5.868.19-7.212 1.535C1 16.326 1 18.8 1 23.75v1.75c0 4.95 0 7.425 1.538 8.962.524.525 1.158.87 1.962 1.098" })
    ], -1)
  ]))]))
}
export default { render: render }